import { useMutation } from "@apollo/client";
import { TrashIcon } from "@heroicons/react/24/outline";
import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { DELETE_FABRICATION } from "../../../../../../../graphql/mutation/Fabrication";
import useUser from "../../../../../../../hooks/useUser";

const Actions = (props = {}) => {
  const {
    id: fabricationId,
    values: { instanceId },
  } = props;
  const { hasPermission } = useUser();
  const [deleteFabrication, { loading, error }] = useMutation(
    DELETE_FABRICATION,
    {
      refetchQueries: ["FetchFabricationsV2"],
    },
  );

  const deleteModalProps = {
    title: "ARE YOU SURE?",
    scale: "sm",
    description: `Would you like to delete this fabrication?`,
    closeOnBackdrop: true,
    renderBody: ({ closeModal }) => {
      const handleDelete = () => {
        deleteFabrication({
          variables: {
            input: {
              id: +fabricationId,
            },
          },
          update: (cache, { data }) => {
            const { deleteFabrication: { success } = {} } = data;
            if (success) {
              closeModal();
              cache.evict({
                id: cache.identify({
                  __typename: "Instance",
                  id: instanceId,
                }),
              });
            }
          },
        });
      };

      return (
        <div className="mt-4 flex-row justify-center">
          {error && <div className="font-bold">{error.message}</div>}
          <Button
            className="mr-3"
            label="Cancel"
            onClick={() => {
              closeModal();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            action="primary"
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {hasPermission("UPDATE_INSTANCE_FABRICATED") && (
          <Modal {...deleteModalProps}>
            <IconButton variant="clean" title="Delete ">
              <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
            </IconButton>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Actions;
